import React, { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: "How does Sonicfit™ work?",
    answer:
      "Sonicfit™ utilizes ultrasonic cavitation treatment, a non-invasive method for targeting and destroying fat cells. It is painless and free of side effects. This treatment effectively isolates and targets fat in problematic areas such as the legs, stomach, and arms. Additionally, it can help reduce stretch marks, tighten skin, and diminish the appearance of cellulite.",
  },
  {
    question: "How does Sonicfit™ feel like to use?",
    answer:
      "Sonicfit™'s ultrasonic cavitation treatment is very gentle, inducing a mild warming sensation with its ultrasonic waves. When using higher intensity modes like 7 and above, you may experience a gentle tingling and buzzing sensation. Overall, this therapy is entirely painless and comfortable, offering a relaxing experience akin to a soothing warm massage on the skin.",
  },
  {
    question: "Do I need to buy a cream as well to use Sonicfit™?",
    answer:
      "While creams are not required to experience Sonicfit™'s benefits, we highly recommend using one with each session. Creams significantly enhance the efficacy of this therapy by improving conductivity, reducing friction between the device and body, and preventing irritation or discomfort. Consider purchasing a device & cream bundle at checkout if you don't already have one. Alternatively, you can use any conductive water-based cream, such as ultrasound gel or aloe vera gel.",
  },
  {
    question: "How should I use Sonicfit™?",
    answer:
      "Use the device in slow, circular motions on one problem area at a time. Although device comes pre-charged from factory, we suggest fully charging and wiping the device with a soft dry cloth before each use.",
  },
  {
    question: "Which mode and intensity level should I choose?",
    answer:
      "Sonicfit™ features three modes: D-Line for skin tightening and stretch mark alleviation, B-fat for fat cell reduction, and L-Skin for anti-cellulite treatment. Each mode offers intensity levels ranging from 1 to 10. Start with a lower intensity and gradually increase it with each session based on your comfort level and desired results. Activate the Heat 🔥 button to enhance the effectiveness of your chosen mode and intensity level.",
  },
  {
    question: "I have sensitive skin. Is it safe for me?",
    answer:
      "Yes, Sonicfit™ is 100% safe for all skin types, even if you have sensitive skin. However, it is important to start at a lower intensity setting in order to gauge your tolerance level. Start with a power level of 1 or 2 and work your way up, as you get more used to the device. Use a smaller amount of our slimming cream or use aloe vera gel instead - about a quarter sized amount per session.",
  },
  {
    question: "How long should I use it for?",
    answer:
      "We recommend using the device for 10-15 minutes per session twice or thrice per week, regardless of the mode & intensity level you choose for each session.",
  },
  {
    question: "How long will it take to see visible results?",
    answer:
      "Our users have reported seeing noticeable results after just a few initial sessions with Sonicfit™. Full results typically appear after using the device consistently for at least three weeks.",
  },
  {
    question: "What if it doesn't work for me?",
    answer:
      "Our device comes with a 90 Day Risk Free Guarantee. We're incredibly confident that you'll get the desired results with Sonicfit™, but if you don't, please contact info@trymagique.com within 90 days of receiving the product for a full refund.",
  },
  {
    question: "Who should NOT use this device?",
    answer:
      "Do NOT use this device if you are pregnant or breastfeeding, have active cancer, severe liver or kidney disease, heart disease, epilepsy, or if you have implanted medical devices such as pacemakers, defibrillators, or metal plates. Always consult with your healthcare provider if you have any medical concerns.",
  },
  {
    question: "What is included with this purchase?",
    answer:
      "Your purchase comes with pre-charged Sonicfit™ device, wiping cloth, user guide, sturdy quality gift box, and a charging USB Type C cable. If you chose a device & a cream bundle, your order will also include our cream as well. Additionally, you'll be sent our video tutorials and provided with any required support to use the device to its full potential.",
  },
  {
    question: "Is my payment information secure?",
    answer:
      "Your data is securely transferred via a SSL encrypted checkout and PCI-compliant network, ensuring it meets the latest security standards. The transmission of your data is always secure and does not pose any risk. Your privacy and security are our top priorities!",
  },
  {
    question: "Are there any recurring charges?",
    answer:
      "All items sold by Sonicfit™ are one-time purchases. There are no recurring charges or billing of any kind, and no hidden fees. Your one-time purchase is fully backed by our 90-day satisfaction guarantee.",
  },
  {
    question: "I have just placed my order - how does the shipping take?",
    answer:
      "Our standard average delivery time is about 7-9 days. If you are based in the U.S., you can expect your delivery within a week if you are closer to the west coast, and around 9-10 days if you are on the east. You can also opt for expedited shipping if timing is crucial to you at the check out for an additional free.",
  },
  {
    question: "I have just placed my order - where is my order confirmation?",
    answer:
      "Order confirmations are automatically sent to the email you used to place your order. If you have not received your order confirmation, please check your spam/promotion folder.",
  },
  {
    question:
      "I have just received my order but I need help using it. Can I speak with someone?",
    answer:
      "Yes, please feel free to reach out to us either via phone (1-855-780-4182) or email (info@trymagique.com).",
  },
  {
    question: "What is your return policy?",
    answer:
      "We are confident that our products work, and we encourage you to try them first and experience the full benefits of Sonicfit™'s ultrasonic cavitation treatments. However, if you are still unhappy and wish to return the items, you may do so within the 90 days period covered by our money-back guarantee. If you have purchased the extended warranty, we will immediately issue a replacement of the product even after 90 days.",
  },
  {
    question: "How soon will I be refunded if I return my device?",
    answer:
      "Once we receive your return, it will take 3-5 business days for our accounting to process your refund, depending on your payment method.",
  },
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="element-wrapper max-w-7xl mx-auto">
      <div className="font-sans leading-tight mt-3 sm:mt-4 p-2 sm:p-3 text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl">
        <div className="paragraph-inner">
          <p className="text-center">
            <strong className="text-inherit bg-transparent">
              Have a Question?{" "}
            </strong>
            <strong>We Are Here to Help!</strong>
          </p>
        </div>
      </div>

      <div className="container-wrapper flex justify-center items-center">
        <div className="container mx-3 sm:mx-4 md:mx-[15px] p-0 flex flex-col items-center justify-center">
          {faqData.map((item, index) => (
            <div key={index} className="element-wrapper w-full">
              <div className="faq-wrapper">
                <div className="faq mt-3 sm:mt-4 md:mt-[15px] mb-0 mx-0 w-full">
                  <div
                    className="faq-header flex justify-between items-center bg-red-100 hover:bg-red-50 border-0 rounded-md p-3 sm:p-4 cursor-pointer"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-title font-sans font-bold text-sm sm:text-base text-left pr-2">
                      {item.question}
                    </div>
                    <svg
                      fill="none"
                      viewBox="0 0 15 15"
                      height="15"
                      width="15"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`faq-icon transform transition-transform shrink-0 w-4 h-4 sm:w-[15px] sm:h-[15px] ${
                        openIndex === index ? "rotate-180" : ""
                      }`}
                    >
                      <path
                        xmlns="http://www.w3.org/2000/svg"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.0581 4.55812L12.9419 5.44187L7.50001 10.8837L2.05814 5.44187L2.94189 4.55812L7.50001 9.11625L12.0581 4.55812Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </div>
                  {openIndex === index && (
                    <div className="faq-content-wrapper">
                      <div className="faq-content border border-red-100 rounded-b-md p-2 sm:p-3">
                        <div className="element-wrapper">
                          <div className="font-sans leading-relaxed my-0.5 sm:my-1 mx-0 p-2 sm:p-3 text-left text-sm sm:text-base md:text-lg">
                            <div className="paragraph-inner">
                              <p>{item.answer}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
